export const visitBanner = {
  title: "Don't stay with doubts!",
  description: "Book your visit on the day and time you want and discover how we work.",
  button: "Book a visit"
};
